(function($) {
	$( '.hero-slider' ).slick(
		{
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			infinity: true,
		}
	);
}(jQuery));
